// @flow
import { call, put, select, takeEvery } from 'redux-saga/effects'
import { startSubmit, stopSubmit } from 'redux-form/immutable'

import { HOLIDAYS_LIST } from '../actionTypes'
import makeAPIRequest from 'store/entities/api/sagas'
import { getPostOrganizationHolidaysList } from 'app/constants/api/orgHolidays'
import { getViewOrganizationSettingsId } from '../../organizations/selectors'
import { showError, showSuccess } from 'store/entities/toastr/utils'
import { HOLIDAYS_UPDATED } from 'app/constants/toastrMessages'
import { ORGANIZATIONS_HOLIDAYS_FORM_NAME as formName } from 'app/constants/organizationHolidays'
import { convertDateToUTC } from 'helpers/timeConvertion'

export default function* takePostSagas(): Generator<*, *, *> {
  yield takeEvery(HOLIDAYS_LIST.POST.REQUEST, postHolidayListSaga)
}

export function* postHolidayListSaga({ payload: { data } }): Generator<*, *, *> {
  const { holidays } = data.toJS()
  const convertedHolidays = convertDateToUTC(holidays)
  yield put(startSubmit(formName))
  try {
    const orgId = yield select(getViewOrganizationSettingsId)
    yield call(makeAPIRequest, getPostOrganizationHolidaysList(orgId), {
      method: 'POST',
      data: {
        holidays: convertedHolidays,
      },
    })
    showSuccess({ content: HOLIDAYS_UPDATED })
  } catch (error) {
    showError()
    console.log(error)
  } finally {
    yield put(stopSubmit(formName))
  }
}
